import React, { useState } from 'react';

import RelativityListsModal from './RelativityListsModal';
import RelativityWorkspacesModal from './RelativityWorkspacesModal';
import { RelativityListType, RelativityWorkspaceType } from '@/api/types/backend-dto-types';

interface RelativityIntegrationModalProps {
  caseId: string;
  onSelectList: (workspace: RelativityWorkspaceType, list: RelativityListType) => void;
  onClose: () => void;
}

type ModalStep = 'workspaces' | 'lists';

const RelativityIntegrationModal: React.FC<RelativityIntegrationModalProps> = ({ caseId, onSelectList, onClose }) => {
  const [currentStep, setCurrentStep] = useState<ModalStep>('workspaces');
  const [selectedWorkspace, setSelectedWorkspace] = useState<RelativityWorkspaceType | null>(null);

  const handleSelectWorkspace = (workspace: RelativityWorkspaceType) => {
    setSelectedWorkspace(workspace);
    setCurrentStep('lists');
  };

  const handleSelectListComplete = (list: RelativityListType) => {
    if (selectedWorkspace) {
      onSelectList(selectedWorkspace, list);
    }
  };

  const handleBackToWorkspaces = () => {
    setCurrentStep('workspaces');
    setSelectedWorkspace(null);
  };

  if (currentStep === 'workspaces') {
    return <RelativityWorkspacesModal onSelectWorkspace={handleSelectWorkspace} onClose={onClose} />;
  }

  if (currentStep === 'lists' && selectedWorkspace) {
    return (
      <RelativityListsModal
        caseId={caseId}
        workspace={selectedWorkspace}
        onSelectList={handleSelectListComplete}
        onBack={handleBackToWorkspaces}
        onClose={onClose}
      />
    );
  }

  return null;
};

export default RelativityIntegrationModal;
